import { Controller } from "@hotwired/stimulus";
import { clearTargetTurboFrame } from "./utils.js";

export default class extends Controller {
  loadRemaining(_event) {
    clearTargetTurboFrame(this.element);
  }
}
